var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgJiffy1St = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 65 12"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#1F1D55",
  d: "M9.552 8.952q-.224 1.041-.7 1.635a3.1 3.1 0 0 1-1.085.922 4.1 4.1 0 0 1-1.338.402q-.73.09-1.457.089l.178-1.026q.224 0 .416-.045a.7.7 0 0 0 .328-.193q.149-.15.282-.446.12-.282.223-.788l1.353-6.394h3.049zm1.606-7.792q0 .342-.15.595-.133.253-.37.43a1.5 1.5 0 0 1-.521.269 2.1 2.1 0 0 1-.61.089q-.595 0-.996-.283-.402-.283-.402-.892 0-.327.134-.58.134-.267.357-.431.238-.179.535-.268.313-.09.64-.089.579 0 .981.283.402.282.402.877"
}), /*#__PURE__*/React.createElement("rect", {
  width: 3.547,
  height: 1.364,
  x: 2.728,
  y: 3.138,
  fill: "#D23731",
  rx: 0.682
}), /*#__PURE__*/React.createElement("rect", {
  width: 3.956,
  height: 1.364,
  x: 1.091,
  y: 8.049,
  fill: "#D23731",
  rx: 0.682
}), /*#__PURE__*/React.createElement("rect", {
  width: 5.73,
  height: 1.364,
  y: 5.593,
  fill: "#D23731",
  rx: 0.682
}), /*#__PURE__*/React.createElement("path", {
  fill: "#06065A",
  d: "M15.192 8.282h1.342q-.012.75.627.75.492 0 .82-.164a1.04 1.04 0 0 0 .486-.492q.165-.334.346-1.348l.98-5.361h1.51l-.984 5.367q-.37 2.016-1.142 2.678-.768.656-2.192.656-.832 0-1.33-.44-.498-.444-.498-1.212 0-.176.035-.434m7.934 1.969h-1.53l1.577-8.584h1.535zm8.678-7.248h-4.13l-.36 1.975h3.018l-.24 1.277h-3.018l-.73 3.996h-1.566l1.594-8.584h5.677zm7.03 0h-4.13l-.358 1.975h3.018l-.24 1.277h-3.018l-.732 3.996H31.81l1.594-8.584h5.678zm4.735 3.451-.697 3.797H41.36l.71-3.844-2.022-4.74h1.588l1.382 3.357 2.573-3.357h1.74zm12.557-4.822-1.594 8.619h-1.588l1.113-6-1.716.838.234-1.553q2.085-.926 2.848-1.904zm3.822 1.607q.484 0 1.258.328l-.453.895q-.47-.41-.86-.41a.77.77 0 0 0-.422.113.34.34 0 0 0-.175.297q0 .23.421.445.426.215.653.344.226.125.371.344c.098.147.148.32.145.496q0 .69-.52 1.09-.516.398-1.32.398-.689 0-1.344-.387l.515-.886q.489.46.957.46a.78.78 0 0 0 .49-.148.48.48 0 0 0 .194-.402q0-.21-.367-.402-.327-.17-.649-.348a1.2 1.2 0 0 1-.43-.387.94.94 0 0 1-.144-.508q0-.61.485-.968.488-.364 1.195-.364m3.988-1.183-.293 1.261h1.145l-.168.786h-1.153l-.42 1.855q-.046.182-.052.371 0 .43.484.43.216 0 .703-.203v.879q-.421.144-1.148.144-.477 0-.766-.297-.288-.296-.289-.773 0-.156.035-.309l.473-2.097h-.484l.168-.786h.484l.164-.855z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h64.788v12H0z"
})))));
export default SvgJiffy1St;